export const linkedWithProvider = (connectedProviders) => {
  const result = Object.keys(connectedProviders)?.filter((item) => {
    return item != 'main' && connectedProviders[item];
  })?.length;
  return Boolean(result);
};

export const checkLinkedProviderWebsite = (connectedProviders) => {
  const result = Object.keys(connectedProviders)?.filter((item) => {
    return item != 'main' && connectedProviders[item];
  })?.length;
  return Boolean(result);
};
